__webpack_require__.p = "/dark-mode-release-2/onboarding/";